import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-footer',
  styleUrl: 'spw-footer.scss',
  shadow: true,
})
export class SpwFooter {
  render() {
    return (
      <Host>
        <footer class="spw-footer">
          <slot></slot>
        </footer>
      </Host>
    );
  }
}
